import { Component } from '@angular/core';
import { ToastService } from '../../../services/toast-service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-toasts',
    templateUrl: './toast-controller.component.html',
    host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index:10002' }
})
export class ToastController {
    constructor(
        public toastService: ToastService,
        private translate: TranslateService
    ) { }
    
    isString(value: any): boolean {
        return typeof value === 'string';
    }
}